export enum DefaultCoinPrizes {
    WON_MATCH = 300,
    LOSE_MATCH = 0,
    TIE_MATCH = 100
}